import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  idLote: number | null;
  onClose: () => void;
}

export function ModalSucessoEditarLote({ show, idLote, onClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={onClose}
      title={idLote ? `Editar - Lote de pagamento ${idLote}` : "Editar lote de pagamento"}
      centered
    >
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: "#e6f9f0",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <FaCheck style={{ color: "#28a745", fontSize: "1.8rem" }} />
        </div>
        <p style={{ marginBottom: 0 }}>Alterações salvas com sucesso!</p>
      </div>
    </ModalCustom>
  );
}
